/*eslint-disable*/
import axios from 'axios';
import { 
    deviceType,
    deviceDetect,
    browserName
} from 'react-device-detect';
import {
    getCurrentTimeZoneDate, 
    normalizeNumber,
    getPlural
} from 'helpers';

const calcType = 'monthly' // monthly -- hourly
const today = Math.floor(Number(new Date().getTime()) / 1000);
const month = calcType === 'monthly' ? 60 * 60 * 24 * 30 : 3600;

const lockupStatusCalc = (allocDate, lockupPeriod) => {
    // The function is called when the status is "lockup"

    const period = lockupPeriod - (today - allocDate);
    let periodDays = Math.floor(period / (3600 * 24));

    if (periodDays <= 0) {
        let minute = Math.ceil(period / 60);
        const hour = Math.floor(minute / 60);
        minute -= hour * 60;

        return `Lockup, ${hour > 0 ? `${hour} ${getPlural(hour, 'hour')}` : ''} ${hour > 0 ? minute : (minute || 60)} ${getPlural(minute, 'minute')} left`;
    }

    const periodMounts = Math.floor(periodDays / 30);
    periodDays -= periodMounts * 30;

    return `Lockup, ${periodMounts} ${getPlural(periodMounts, 'month')} ${periodDays} ${getPlural(periodDays, 'day')} left`;
};

const getNextClaim = (allocDate, lockupPeriod, amountRemaining) => {
    // The function is called when "Claim Now" is not available

    if (!amountRemaining) {
        return 'You claimed all funds';
    }

    const period = (lockupPeriod + (calcType === 'monthly' ? 30 * 3600 * 24 : 3600)) - (today - allocDate);
    let periodDays = Math.floor(period / (3600 * 24));

    if (periodDays <= 0) {
        let minute = Math.ceil(period / 60);
        const hour = Math.floor(minute / 60);
        minute -= hour * 60;
        
        return `${hour > 0 ? `${hour} ${getPlural(hour, 'hour')}` : ''} ${hour > 0 ? minute : (minute || 60)} ${getPlural(minute, 'minute')} left to claim`;
    }

    const periodMounts = Math.floor(periodDays / 30);
    periodDays -= periodMounts * 30;
    periodDays = !periodMounts && !periodDays ? 30 : periodDays;

    return `${periodMounts > 0 ? `${periodMounts} ${getPlural(periodMounts, 'month')}` : ''} ${periodDays ? `${periodDays} ${getPlural(periodDays, 'day')}` : ''} left to claim`;
};

const claimDataCalc = ({
    allocationTime, amountClaimed, amount, allocationType, amountRemaining, availableAmount, state, vesting, lockupPeriod
}, auth) => {
    const allocDate = new Date(getCurrentTimeZoneDate(allocationTime));
    // const allocDate = new Date('2022-11-16 22:04:00'); // for testing
    const allocDateToTime = Math.floor(Number(allocDate.getTime()) / 1000);
    const allocDateDay = (allocDate.getDate().toString().length === 1 ? '0' : '') + allocDate.getDate();
    const allocDateMonth = ((allocDate.getMonth() + 1).toString().length === 1 ? '0' : '') + (allocDate.getMonth() + 1);
    const allocDateYear = allocDate.getFullYear();

    const lockupMounts = lockupPeriod / month;
    const vestingToMonth = vesting / month;
    const monthlyUnlock = Math.floor(100 / (vestingToMonth || 1));
    const isNoLockup = (today > allocDateToTime + lockupPeriod) && 'No Lockup';

    let unlockedPercent = null;
    if (isNoLockup) {
        const pastTense = Math.floor(today - (allocDateToTime + lockupPeriod)) / month;
        unlockedPercent = Math.floor(pastTense * 100 / vestingToMonth);
        unlockedPercent = normalizeNumber(unlockedPercent > 100 ? 100 : unlockedPercent < 0 ? 0 : unlockedPercent, 3);
    }

    const lockupStatus = !isNoLockup ? lockupStatusCalc(allocDateToTime, lockupPeriod) : isNoLockup;
    const nextClaimWillAvailable = !availableAmount ? getNextClaim(allocDateToTime, lockupPeriod, amountRemaining) : null;
    const currStatus = lockupStatus + (isNoLockup ? `, ${unlockedPercent}% unlocked` : '');
    if(currStatus.includes('NaN')) {
        axios({
            method: 'post',
            url: 'https://service.fasttoken.com/email/debug',
            data: {
                data: JSON.stringify({
                    allocation: {
                        allocationTime, amountClaimed, amount, allocationType, amountRemaining, availableAmount, state
                    },
                    allocDate,
                    variables: {
                        allocDateToTime,
                        allocDateDay,
                        allocDateMonth,
                        allocDateYear,
                        lockupMounts,
                        monthlyUnlock,
                        isNoLockup,
                        today,
                    },
                    auth,
                    deviceType,
                    deviceDetect: deviceDetect(),
                    browserName
                })
            },
        }).then(res => {
            console.log(res);
        });
    }

    return {
        type: allocationType,
        totalAlloc: `${amount} FTN`,
        unlockCondition: `${lockupMounts} ${getPlural(lockupMounts, calcType === 'monthly' ? 'month' : 'hour')} lockup, ${monthlyUnlock}% ${calcType} unlock`,
        currStatus,
        allocationDate: `${allocDateDay}.${allocDateMonth}.${allocDateYear}`,
        claimed: `${amountClaimed} FTN`,
        totalUnclaimed: `${amountRemaining} FTN`,
        availableClaim: `${availableAmount} FTN`,
        state,
        nextClaimWillAvailable,
    };
};

export default claimDataCalc;
